/**
 * Slice: store.tasteProfileOnboarding
 */
import humps from 'humps'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'

import questionReducer from './containers/Question/reducer'
import resultReducer from './containers/PersonalTasteProfile/reducer'
import {
  filtersReducer,
  orderingsReducer,
  getInitialState as getInitialFiltersState
} from './reducers'
import storageAvailable from 'utils/storageAvailable'
import getValidatedState, { initialState } from './utils/getValidatedState'

const getInitialState = () => {
  let startState = initialState
  if (storageAvailable('localStorage')) {
    let localStorageDataVersion = localStorage.getItem('data-version')
    let persistedState = localStorage.getItem('tasteProfileOnboardingState')

    try {
      localStorageDataVersion = JSON.parse(localStorageDataVersion)
      persistedState = JSON.parse(persistedState)
    } catch (e) {
      // fail silently, since we fall back to initial blank state in getValidatedState
    }

    if (localStorageDataVersion === process.env.LOCALSTORAGE_DATA_VERSION) {
      startState = getValidatedState(persistedState)
    }
  }

  // used on `/accounts/smaakprofiel/`
  // should override localStorage data if that's also available
  if (window.tasteProfileStore) {
    startState.result = humps.camelizeKeys(window.tasteProfileStore)
  }

  // setup filters based on saved taste profile
  const savedResult = startState.result
  if (!isEmpty(savedResult)) {
    const tasteProfiles = sortBy(savedResult.tasteProfiles, (tasteProfile) => tasteProfile.color)
    const initialFiltersState = getInitialFiltersState(tasteProfiles)
    startState.filters = initialFiltersState.filters
    startState.orderings = initialFiltersState.orderings
  }

  return startState
}

// Return a slice of the state
export default (state = getInitialState(), action) => ({
  questions: questionReducer(state.questions, action),
  result: resultReducer(state.result, action),
  filters: filtersReducer(state, action),
  orderings: orderingsReducer(state, action)
})
